module.exports = function anonymous(it
) {
var out='<li class="log-entry notification"> <div class="log-header light-color-entry"> ';if(it.loading){out+=' <span class="loading log-loading">'+(it.loading)+'</span> ';}else{out+=' <span class="loading log-loading" rel="localize[log.loading]">Loading logs ...</span> ';}out+=' </div></li>';return out;
}